import { Button } from '@mui/material'
import type { SyntheticEvent } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import MdiBadgeOutline from '~icons/mdi/badge-outline'
import MingcuteDiamond2Line from '~icons/mingcute/diamond-2-line'
import { cx } from 'src/utils/cx'
import { track } from 'src/utils/tracker'
import MarkdownRenderer from '../ui/MarkdownRenderer'

function useVerifyEmailModal(options?: {
  trackingProps?: Record<string, string | undefined>
  onClose?: () => any
}) {
  const onActionClick = (e: SyntheticEvent<HTMLElement>) => {
    track('lora_train_click', {
      ...options?.trackingProps,
    })
    e.stopPropagation()
  }

  return { onActionClickForVerifyEmail: onActionClick }
}

export function TrainLoraCreditRebateBanner(props: { className?: string }) {
  const { t } = useTranslation(['growth'])
  return (
    <div className={cx('w-full flex justify-center', props.className)}>
      <div className="p-2 max-w-[800px] bg-[#7f3fd9]/10 flex items-center rounded-xl gap-4">
        <MarkdownRenderer className="prose prose-sm leading-normal dark:prose-invert !text-theme-primary [&_strong]:text-theme-primary ">
          {t('growth:train-lora.credit-rebate.content')}
        </MarkdownRenderer>
      </div>
    </div>
  )
}

// TODO: Not used anymore. Mind the i18n messages before removal
export function TrainLoraCreditBanner(props: { onClose?: () => any }) {
  const { t } = useTranslation(['growth'])
  const { onActionClickForVerifyEmail } = useVerifyEmailModal({
    onClose: props.onClose,
    trackingProps: {
      location: 'profile-credit',
    },
  })

  return (
    <div
      className={cx(
        'w-full flex flex-col justify-center relative p-4 rounded-t-2xl',
        'bg-[percentage:75%] bg-[top_35%_right_-80%] bg-no-repeat',
      )}
      style={{
        backgroundImage: `url(${t('growth:train-lora.credit-banner.banner')})`,
      }}
      role="button"
      onClick={onActionClickForVerifyEmail}
    >
      <MdiBadgeOutline className="absolute z-[-1] text-stone-400/20 top-4 left-4 text-8xl" />
      <p className="font-bold leading-none">PixAI</p>

      <p className="font-bold text-theme-primary text-4xl">
        {t('growth:train-lora.credit-banner.title')}
      </p>
      <p className="shrink min-w-0 text-2xl tracking-tight drop-shadow-[2px_2px_2px_#FFF]">
        <Trans
          t={t}
          i18nKey="growth:train-lora.credit-banner.content.first-line"
          components={{
            strong: <strong />,
          }}
        />
      </p>
      <p className="shrink min-w-0 text-2xl tracking-tight drop-shadow-[2px_2px_2px_#FFF]">
        <Trans
          t={t}
          i18nKey="growth:train-lora.credit-banner.content.second-line"
          components={{
            strong: <strong />,
          }}
        />
      </p>
      <Button
        className="bg-theme-primary text-white text-xs mt-10 w-fit rounded-full px-10"
        variant="contained"
        onClick={onActionClickForVerifyEmail}
        component={Link}
        to="/train-lora"
      >
        {t('growth:train-lora.credit-banner.action-label')}
      </Button>
    </div>
  )
}

export function NavToTrainLoraPageButton(props: {
  className?: string
  from?: string
}) {
  const { t } = useTranslation(['growth'])
  const { onActionClickForVerifyEmail } = useVerifyEmailModal({
    trackingProps: {
      location: props.from,
    },
  })
  return (
    <Button
      variant="outlined"
      component={Link}
      to="/train-lora"
      startIcon={<MingcuteDiamond2Line className="size-5" />}
      className={cx(
        'border-theme-primary text-theme-primary font-semibold rounded-lg',
        props.className,
      )}
      onClick={onActionClickForVerifyEmail}
    >
      {t('growth:train-lora.train-your-own-lora.nav-label')}
    </Button>
  )
}
